import { Device, Theme } from '@livecontrol/core-ui';
import { Obj } from '@livecontrol/core-utils';
import { Filters } from '@livecontrol/scheduler/components';
import { Scheduler } from '@livecontrol/scheduler/store';
import type { ReactElement } from 'react';
import styled from 'styled-components';
import { Sorting as SortFilter } from '../../../../components';
import { Store } from '../../../../store';
import { Actions as A } from '../../common';
import { T_Sorting } from '../../store';
import type { Location } from '../../store';

const ActionsSection = styled.div`
  &.is-mobile > div {
    margin-right: 8px;
    margin-bottom: 10px;
  }
  .search-section {
    border: solid 1px #8798ad;
    background-color: white;
    input {
      font-size: 12px;
      font-weight: bold;
      &::placeholder,
      &::-ms-input-placeholder {
        color: #0d1438 !important;
        opacity: 1;
        font-size: 12px;
        font-weight: bold;
      }
      &::placeholder {
        color: #0d1438 !important;
        opacity: 1;
        font-size: 12px;
        font-weight: bold;
      }
    }
  }

  &.is-mobile .search-section {
    max-width: 300px;
    height: 36px;
  }
`;

interface ActionsProps {
  onChangeKeyword: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeLocation: (value?: Location | Location[]) => void;
  valueLocation: Location | undefined;
  onChangeDate: (v?: Filters.Period.Value) => void;
  onChangeSorting: (value: T_Sorting) => void;
  valueSorting: T_Sorting;
  valueKeyword: string | undefined;
  valueDate:
    | Partial<{
        min: Date;
        max: Date;
      }>
    | undefined;
}

export const Actions = ({
  onChangeKeyword,
  valueKeyword,
  onChangeDate,
  onChangeSorting,
  valueSorting,
  valueDate,
  onChangeLocation,
  valueLocation,
  ...props
}: A.Props & ActionsProps): ReactElement => {
  const viewport = Theme.useViewport();
  const size = Device.isMobile(viewport) ? 'sm' : 'lg';
  const isMobile = Device.isMobile(viewport);
  const account = Store.Account.useAccount();
  const { locations } = Scheduler.Location.useLocations(account);
  const today = new Date();

  const { keys } = T_Sorting;

  const sortingAvailable = Obj.keys(keys).map((key) => ({
    key,
    label: keys[key]
  }));

  return (
    <ActionsSection
      className={`d-flex flex-wrap justify-content-end ${isMobile ? 'is-mobile' : ''}`}
    >
      {!isMobile && (
        <A {...props}>
          <Filters.Period onChange={onChangeDate} pickerProps={{maxDate: today}} value={valueDate} size={size} />
          {locations && (
            <Filters.Location
              onChange={onChangeLocation}
              value={{ available: locations, selected: valueLocation }}
              size={size}
            />
          )}
          <SortFilter
            value={{ available: sortingAvailable, selected: valueSorting }}
            onChange={onChangeSorting}
            size={size}
          />
          <Filters.Keyword
            placeholder='Search'
            onChange={onChangeKeyword}
            value={valueKeyword}
            htmlSize={30}
            size={size}
            className='search-section'
          />
        </A>
      )}
      {isMobile && (
        <>
          <Filters.Period onChange={onChangeDate} value={valueDate} pickerProps={{maxDate: today}} size={size} />
          <SortFilter
            value={{ available: sortingAvailable, selected: valueSorting }}
            onChange={onChangeSorting}
            size={size}
          />
          <Filters.Keyword
            placeholder='Search'
            onChange={onChangeKeyword}
            value={valueKeyword}
            htmlSize={30}
            size={size}
            className='search-section'
          />
        </>
      )}
    </ActionsSection>
  );
};
